<template>
    <div class="com-banner" :_src="bannerHead._src">
        <div class="center clearfix">
            <div class="banner-pro" :bannerpro="bannerHead">
                <h1>{{bannerHead.title}}</h1>
                <p>{{bannerHead.msg}}</p>
            </div>
            <img :src="bannerHead.imgSrc" :_src="bannerHead.imgSrc1" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        props:['bannerHead'],
        methods: {},
        components: {},
        computed: {}
    }
</script>

<style lang="less">
    @baseWidth:1640px;
    .center{
        width: @baseWidth;
        margin: 0 auto;
    }
    .com-banner {
        height: 530px;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-items: center;
        h1 {
            font-size: 40px;
            line-height: 64px;
            margin-bottom: 8px;
            font-weight: 300;
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
        }
        p {
            font-size: 16px;
            line-height: 24px;
        }
        .banner-pro {
            /*width: 1640px;*/
            /*margin: 0 auto;*/
            /*padding-left: 140px;*/
            color: #fff;
        }
    }
    @media screen and (max-width: 1680px){
        @baseWidth:1216px;
        .center{
            width: @baseWidth;
            margin: 0 auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/common/banHead.vue